var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',[_vm._v("This template produces file sources of type "),_c(_setup.FileSourceTypeSpan,{attrs:{"type":_setup.fileSourceType}}),_vm._v(".")],1),_vm._v(" "),_c(_setup.ConfigurationMarkdown,{attrs:{"markdown":_vm.template.description || '',"admin":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }